import {
  AttendanceActionTypes,
  CheckinActionTypes
} from './attendance.types';

export const GET_ATTENDANCE: AttendanceActionTypes = 'GET_ATTENDANCE';
export const CHECKIN: CheckinActionTypes = 'CHECKIN';
export const UNCHECKIN: CheckinActionTypes = 'UNCHECKIN';
export const ANTI_IDLE: CheckinActionTypes = 'ANTI_IDLE';
export const UPDATE_ATTENDANCE_AFTER_CHECKIN: AttendanceActionTypes = 'UPDATE_ATTENDANCE_AFTER_CHECKIN';

export const DEFAULT_NOT_CHECKED_IN = 0;



// WEBPACK FOOTER //
// ./src/attendance/attendance.constants.tsx